export default __webpack_public_path__ + "logo-second.cd87eff2.svg";